import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardTitle, Media } from "reactstrap";
import SimpleBar from "simplebar-react";


//i18n
import { withNamespaces } from "react-i18next";


const OrderProductSections = (props) => {


  const role = localStorage.getItem("role");
  const getLink = (section, type) => {
    let pageLink = "";

    switch (type) {
      case "new_orders":
        pageLink =
          "/finished_products/all_orders_new?status=New&section=" + section;
        break;

      case "orders_in_process":
        pageLink =
          "/finished_products/all_orders_new?status=In Process&section=" +
          section;
        break;

      case "closed_orders":
        pageLink =
          "/finished_products/all_orders_new?status=Closed&section=" + section;
        break;
    }
    return pageLink;
  };

  const getbgColor = () => {
    let color = "";
    switch (props.type){
      case "new_orders" :
        color="#e3f2fd"
        break;
      case "orders_in_process" :
        color="#fff8e1"
        break;
      case "closed_orders" :
        color="#e8f5e9"
        break;
    }
    return color
  }

  const getFontColor = () => {
    let color = "";
    switch (props.type){
      case "new_orders" :
        color="#0d47a1"
        break;
      case "orders_in_process" :
        color="#f57f17"
        break;
      case "closed_orders" :
        color="#1b5e20"
        break;
    }
    return color
  }

  const getBorderColor = () => {
    let color = "";
    switch (props.type){
      case "new_orders" :
        color="1px solid #9eb3e8"
        break;
      case "orders_in_process" :
        color="1px solid #f7dc79"
        break;
      case "closed_orders" :
        color="1px solid #9dde81"
        break;
    }
    return color
  }
  return (
    <>
      {" "}
      <Card>
        <CardBody>
          <CardTitle>{props.heading}</CardTitle>

          {props.sections && props.sections.length > 0 ? (
            <>
              <div
                style={{
                  height: "90px",
                  overflowX: "auto",
                  overflowY: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {props.sections &&
                  props.sections.map((section) => {
                    return (
                      <Link
                        to={() => {
                          return getLink(section.section, props.type);
                        }}
                        style={{ display: "inline-block" }}
                      >
                        <Card
                          className={"mini-stats-wid mr-4"}
                          style={{width: "auto",backgroundColor: getbgColor(), border:getBorderColor()}}
                        >
                          <CardBody>
                            <Media>
                              <Media body>
                                {/* <p
                                className="fw-medium"
                                style={{ color: "white" }}
                              >
                                {section.section}
                              </p> */}
                                <h5 className="mb-0" style={{ color: getFontColor() }}>
                                  {section.section}
                                </h5>
                              </Media>
                            </Media>
                          </CardBody>
                        </Card>
                      </Link>
                      // <Link
                      //   to={() => {
                      //     return getLink(section.section, props.type);
                      //   }}
                      //   className="text-reset notification-item"
                      // >
                      //   <div className="media">
                      //     <div className="avatar-xs ">
                      //       <i class="bx bx-right-arrow-circle font-size-18"></i>
                      //     </div>
                      //     <div className="media-body">
                      //       <h5 className="mt-0 mb-1">{section.section}</h5>
                      //     </div>
                      //   </div>
                      // </Link>
                    );
                  })}
              </div>
            </>
          ) : (
            <SimpleBar style={{ height: "80px" }}>
              <Link to="" className="text-reset notification-item">
                <div className="media">
                  <div className="media-body">
                    <h6 className="mt-0 mb-1"></h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">There are no sections.</p>
                    </div>
                  </div>
                </div>
              </Link>
            </SimpleBar>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default withNamespaces()(OrderProductSections);
